/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "20375dfdb4784bc84780380ca91468ada520d858";
